module.exports = __webpack_public_path__ + "img/python.3d665b9f.png";